import { StatusBadge } from '@/components/common/StatusBadge';
import {
  SUBMISSION_STATUS_LABELS,
  SUBMISSION_STATUS_TONE,
} from '../constants/instituteSubmission.constants';
import type { SubmissionStatus } from '../types/instituteSubmission.types';

interface InstituteSubmissionStatusBadgeProps {
  status: SubmissionStatus;
  className?: string | undefined;
}

export function InstituteSubmissionStatusBadge({
  status,
  className,
}: InstituteSubmissionStatusBadgeProps) {
  return (
    <StatusBadge tone={SUBMISSION_STATUS_TONE[status]} className={className}>
      {SUBMISSION_STATUS_LABELS[status]}
    </StatusBadge>
  );
}
